import React from 'react';
import Loading from 'components/pure/utils/Loading';
import './DashV2MainWidgetLoader.styl';

const DashV2MainWidgetLoader = () => {
  return (
    <div className="standalone-widget-wrapper">
      <div className="widget dashv2-loading-widget">
        <Loading />
      </div>
    </div>
  );
};

export default DashV2MainWidgetLoader;
